import * as React from 'react';
import { Box, Group, Button, Textarea, NumberInput } from '@mantine/core'
import  { useForm, isNotEmpty } from "@mantine/form";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import { showMessage } from "../../lib/notification";
import { DatePicker } from "@mantine/dates";
import type { IResponse } from "../../types/api";
import type { ISongGroup } from "./types";
import dayjs from "dayjs";
import Page from "../../components/layout/Page";

interface FormValues extends Pick<ISongGroup, 'groupNumber' | 'description'> {
    addedDate: Date;
}

interface IParams extends Pick<ISongGroup, 'addedDate' | 'groupNumber' | 'description'> {
}

const CreateCategory = () => {

    const navigate = useNavigate();

    const form = useForm<FormValues>({
        initialValues: {
            addedDate: new Date(),
            description: "",
            groupNumber: 0
        },
        validate: {
            addedDate: isNotEmpty('Харгалзах өдөр оруулна уу'),
            groupNumber: isNotEmpty('Бүлгийн дугаар оруулна уу'),
        },
    });

    const handleSubmit = async (values: FormValues) => {
        const bodyParam: IParams = {
            ...values,
            addedDate: dayjs(values.addedDate).format('YYYY-MM-DD'),
        }
        const { data } = await axios.post<IResponse<any>>(API_ROUTE, bodyParam);
        if (data.statusCode === 200) {
            navigate(CLIENT_ROUTE);
            showMessage('Амжилттай', 'green');
        } else {
            showMessage('Алдаа гарлаа');
        }
    }

    return (
        <Page>
            <Page.Header title={`${CLIENT_TITLE} үүсгэх`} backRoute={CLIENT_ROUTE}/>
            <Page.Body>
                <Box sx={{ maxWidth: 500 }} mx="auto">
                    <form>
                        <NumberInput
                            withAsterisk
                            label="Бүлгийн дугаар"
                            placeholder="Бүлгийн дугаар"
                            {...form.getInputProps('groupNumber')}
                        />

                        <DatePicker
                            withAsterisk
                            placeholder="Харгалзах өдөр"
                            label="Харгалзах өдөр"
                            {...form.getInputProps('addedDate')}
                        />

                        <Textarea
                            label="Тайлбар"
                            placeholder="Тайлбар..."
                            {...form.getInputProps('description')}
                        />
                    </form>
                </Box>
            </Page.Body>
            <Page.Footer>
                <Group position="right" mt="md">
                    <Button color='color-secondary' onClick={() => form.onSubmit(handleSubmit)()}>Хадгалах</Button>
                </Group>
            </Page.Footer>
        </Page>
        );
};

export default CreateCategory;